import PropTypes from "prop-types";
import TechBankerTimeLog from "./tech-banker-time-log/tech-banker-time-log";

const DashboardTechBanker = (props) => {
  return (
    <div>
      {(props.techBankerTimeLogItems) &&
        <TechBankerTimeLog items={props.techBankerTimeLogItems}/>
      }
    </div>
  );
};

DashboardTechBanker.propTypes = {
    techBankerTimeLogItems: PropTypes.array,
};

export default DashboardTechBanker;